__turbopack_context__.v({
  "chip": "AvailabilityChip-module-scss-module__dVKm8a__chip",
  "dot": "AvailabilityChip-module-scss-module__dVKm8a__dot",
  "full": "AvailabilityChip-module-scss-module__dVKm8a__full",
  "label": "AvailabilityChip-module-scss-module__dVKm8a__label",
  "pulse": "AvailabilityChip-module-scss-module__dVKm8a__pulse",
  "short": "AvailabilityChip-module-scss-module__dVKm8a__short",
});
